import { translationBaseKey } from '../decorators/translation-base-key.decorator';
import { IsOptional, IsString } from '@pristine-ts/class-validator';
import { ErrorMessageBuilder } from '../builders/error-message.builder';
import {advancedFormControl, FormControlTypeEnum} from "@magieno/common";

@translationBaseKey('user-update-options')
export class UserUpdateOptions {
  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Prénom',
        en: 'First name',
      },
    },
    type: FormControlTypeEnum.Input
  })
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  firstName: string;


  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Nom',
        en: 'Last name',
      },
    },
    type: FormControlTypeEnum.Input
  })
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  lastName: string;

  @IsOptional()
  @IsString()
  phoneNumber?: string;

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Langue',
        en: 'Language',
      },
    },
    type: FormControlTypeEnum.Select,
    items: [
      {
        label: {
          fr: 'Français',
          en: 'Français',
        },
        id: 'fr',
      },
      {
        label: {
          fr: 'English',
          en: 'English',
        },
        id: 'en',
      },
    ],
  })
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsOptional()
  language?: string;
}
